goog.provide('el8.apphome.reqAct.QueueFeed');

goog.require('el8.uiwidget.Feed');
goog.require('el8.util.consts');
goog.require('el8.model.base');
goog.require('el8.apphome.reqAct.actions');
goog.require('el8.apphome.reqAct.reqActPatients');

el8.apphome.reqAct.QueueFeed = function(spec) {

    this._tabName = spec.tabName;
    this._urlName = spec.urlName || this._tabName;

    spec.clickTriggerMap = el8.apphome.reqAct.actions.clickMap;
    el8.uiwidget.Feed.prototype.constructor.call(this, spec);

    if (spec.updateCallbackFn) { this.bind('all', spec.updateCallbackFn); }

    /* Extend feedRenderer's renderEmpty() method to do UIM tracking */
    var super_renderEmpty = this._feedRenderer.renderEmpty;
    var that = this;
    this._feedRenderer.renderEmpty = function() {
        super_renderEmpty.call(that._feedRenderer);
    };
};
el8.apphome.reqAct.QueueFeed.inheritsFrom(el8.uiwidget.Feed);

/**
 * Method to change the endpoint URL that feeds this index, and therefore clear out
 * the dataIndex
 */
el8.apphome.reqAct.QueueFeed.prototype.updateIndexUrl = function(queueType) {
    this._urlIndex = el8.service.urls.get('reqActFeedIndex', [this._urlName, queueType]);
    this._feedData.reset();
    // rest render?
};
el8.apphome.reqAct.QueueFeed.prototype.isSelfQueue = function() {
    return this._urlIndex === el8.service.urls.get('reqActFeedIndex',
            [this._urlName, String(el8.data.currUser.getId())]);
};

/**
 * Update UI after a ReqActPatient with a message thread / letter with comments is dealt with
 *
 * idToRemove can be either a threadId or a letterId
 */
el8.apphome.reqAct.QueueFeed.prototype.updatePatientAfterResponse = function(patientId, idToRemove) {
    this.unfreeze();
    var patient = el8.apphome.reqAct.reqActPatients.getById(patientId);
    if (idToRemove) {
        patient.removeDataItem(idToRemove);
    }
    if (!patient.getData().length) {
        this.remove(patientId, el8.util.consts.DEFAULT_DURATION);
    } else {
        this.refreshItem(patient, false);
    }
    this.trigger('update');
};

/**
 * Fetch the first X number of ReqActPatient objects in the feed
 */
el8.apphome.reqAct.QueueFeed.prototype.getReqActPatientIds = function(count) {
    var index = this.getIndex();
    var reqActPatientIds = _.map(
        _.filter(index, function(obj) { return obj['model_class'] === 'ReqActPatient'; }),
        function(obj) { return obj['id']; });
    return reqActPatientIds.slice(0, count);
};

/**
 * Useful helper function
 */
el8.apphome.reqAct.QueueFeed.prototype.getTabName = function() {
    return this._tabName;
};
